import {GalleryUnitElement} from './GalleryUnitElement';

export class GalleryOverview {
  galleryRespondentUnit:GalleryUnitElement[];
  totalResp = 0;
  pId = 0;
  qId = 0;
  projectName:string;
  otherFolders:string[];

  constructor(json:any) {

    if(json!=null) {
      this.galleryRespondentUnit = [];
      for(const obj of json.galleryRespondentUnit) {
        this.galleryRespondentUnit.push(new GalleryUnitElement(obj));
      }

      this.totalResp = json.totalResp;
      this.pId = json.pId;
      this.qId =json.qId;
      this.projectName = json.projectNAme;
      this.otherFolders = json.otherFolders;
    }
  }

  public getImgLinks():string[] {
    const urlsArr = [];

    for(const elem of this.galleryRespondentUnit) {
      urlsArr.push(elem.getImgUrl());
    }
    return urlsArr;
  }

  public insertGalleryUnit(unit:GalleryUnitElement) {
    if(this.galleryRespondentUnit == null) {
      this.galleryRespondentUnit = [];
    }
    this.galleryRespondentUnit.push(unit);
  }
}
